const config = {
  rowSelection: true,
  columns: [
    {
      title: '收款单号',
      dataIndex: 'transactionCode',
      width: 190,
      ellipsis: true,
    },
    {
      title: '支付方式',
      dataIndex: 'paymentMethodName',
      width: 150
    },
    {
      title: '收款金额',
      dataIndex: 'amount',
      width: 140,
    },
    {
      title: '已核销金额',
      dataIndex: 'verifiedAmount',
      width: 140,
    },
    {
      title: '未核销金额',
      dataIndex: 'unverifiedAmount',
      width: 140
    },
    {
      title: '核销状态',
      dataIndex: 'verifyStateName',
      width: 100
    },
    {
      title: '收款日期',
      dataIndex: 'receivedDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '到账日期',
      dataIndex: 'accountingDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '确认收款操作时间',
      dataIndex: 'receivedClickDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '是否客户收款',
      dataIndex: 'customerReceiptFlag',
      render: 'receiptFlagOperate',
      width: 150
    },
    {
      title: '收款状态',
      dataIndex: 'stateName',
      width: 120
    },
    {
      title: '收款账户',
      dataIndex: 'cardNo',
      ellipsis: true,
      width: 180
    },
    {
      title: '付款账户',
      dataIndex: 'paymentAccount',
      ellipsis: true,
      width: 180
    },
    {
      title: '第三方订单号',
      dataIndex: 'shjThirdOrderNoInfo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '第三方合同号',
      dataIndex: 'shjThirdContractNoInfo',
      width: 180,
      ellipsis: true,
    },
    {
      title: '来源类型',
      dataIndex: 'sourceTypeName',
      width: 120
    },
    {
      title: '交易类型',
      dataIndex: 'transactionTypeName',
      width: 120
    },
    {
      title: '交易流水号',
      dataIndex: 'paymentOrderTransactionId',
      width: 180,
      ellipsis: true,
    },
    {
      title: '打印状态',
      dataIndex: 'printStateName',
      width: 120
    },
    {
      title: '收据方式',
      dataIndex: 'printTypeName',
      width: 120
    },
    {
      title: '收据编号',
      dataIndex: 'printNo',
      ellipsis: true,
      width: 180
    },
    {
      title: '同步金蝶交易流水数据消息记录',
      dataIndex: 'kdReceiptCreateMsg',
      render: "kdReceiptOperate",
      width: 230
    },
    {
      title: '备注',
      dataIndex: 'description',
      width: 200,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 200,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'paymentMethodList',
      label: '支付方式',
      itemType: 'select',
      data: 'paymentMethodList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'verifyStateList',
      label: '核销状态',
      itemType: 'select',
      data: 'verifyStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'customerReceiptFlag',
      label: '是否客户收款',
      itemType: 'select',
      data: 'customerReceiptFlagList',
      labelKey: 'name',
      key: 'id',
    },
    {
      name: 'stateList',
      label: '收款状态',
      itemType: 'select',
      data: 'receiptStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'transactionTypeList',
      label: '交易类型',
      itemType: 'select',
      data: 'transactionFeeTypeList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'receivedDate',
      label: '收款日期',
      itemType: 'autoDate',
      allowClear: 'true'
    }
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      auth: 'PaymentDetailsAdd',
      events: ['onClick:onAdd'],
    },
    {
      label: '优惠查询',
      auth: 'couponQueryAuth',
      events: ['onClick:onCouponQuery'],
    },
    {
      label: '收款计算（新）',
      auth: 'newCollectionCountAuth',
      events: ['onClick:onNewCollectionCount'],
    },
    {
      label: '收款计算',
      auth: 'collectionCountAuth',
      events: ['onClick:onCollectionCount'],
    },
    {
      label: '转款',
      auth: 'PaymentDetailsTransferFunds',
      events: ['onClick:onTransferFunds'],
    },
    {
      label: '转款查询',
      auth: 'PaymentDetailsTransfer',
      events: ['onClick:onTransfer'],
    },
  ],
  batchActions: [
    {
      label: '批量确认到账',
      type: 'primary',
      auth: 'PaymentDetailsConfirmReceipt',
      events: ['onClick:onConfirmReceiptShowModal'],
    }
  ]
}

export default config
